import { graphql, useStaticQuery } from 'gatsby';
import React, { useRef, useState } from 'react';
import Dropdown from 'react-dropdown-select';

import { mapEdgesToNodes } from '../../utils/helpers';
import { handleDirectoryRedirect } from '../../utils/states-redirect';

const STATE_VISIBILTY_STATUSES = {
	allStates: 'allStates',
	availableStates: 'availableStates',
	availableAndLimitedStates: 'availableAndLimitedStates',
	custome: 'custom',
};

const STATE_STATUSES = {
	AVAILABLE: 'Available',
	UNAVAILABLE: 'Unavailable',
	COMINGSOON: 'Coming Soon',
	LIMITED: 'Available (limited)',
};

export function StatesDropdown({
	formToScrollTo,
	type = 'states',
	removeServicesAvailability,
	statesDropdown,
}) {
	// hooks
	const locationEl = useRef();
	const servicesEl = useRef();

	// state
	const [selectedState, setSelectedState] = useState();
	const [selectedServices, setSelectedServices] = useState();
	const [selectedStateStatus, setSelectedStateStatus] = useState(
		STATE_STATUSES.AVAILABLE
	);

	const statesVisibility = statesDropdown?.statesVisibility;
	const servicesVisibility =
		!removeServicesAvailability && statesDropdown?.servicesVisibility;

	const data = useStaticQuery(graphql`
		query States {
			states: allSanityState {
				edges {
					node {
						id
						title
						stateStatus
					}
				}
			}
			services: allSanityService(sort: { orderRank: ASC }) {
				edges {
					node {
						id
						title
						value
					}
				}
			}
		}
	`);

	const statesNodes = (data || {}).states ? mapEdgesToNodes(data.states) : [];
	const serviceNodes = (data || {}).services
		? mapEdgesToNodes(data.services)
		: [];

	let statesOptions;

	if (statesVisibility === STATE_VISIBILTY_STATUSES.custom) {
		statesOptions = statesNodes.map((state) => ({
			value: state.title.replace(/ /g, ''),
			label: state.title,
			status: state.stateStatus,
		}));
	} else {
		statesOptions = statesNodes
			.filter((state) => {
				return state.stateStatus === STATE_STATUSES.AVAILABLE;
			})
			.sort((a, b) => (a.title < b.title ? -1 : 1))
			.concat(
				statesNodes
					.filter(
						(state) => state.stateStatus === STATE_STATUSES.LIMITED
					)
					.sort((a, b) => (a.title < b.title ? -1 : 1))
			)
			.concat(
				statesNodes
					.filter(
						(state) =>
							state.stateStatus === STATE_STATUSES.UNAVAILABLE
					)
					.sort((a, b) => (a.title < b.title ? -1 : 1))
			)
			.map((state) => ({
				value: state.title.replace(/ /g, ''),
				label: state.title,
				status: state.stateStatus,
			}));
	}

	const addStateStatusSpan = async () => {
		setTimeout(() => {
			locationEl.current.select.current
				.querySelectorAll('.react-dropdown-select-item')
				.forEach((stateSpan) => {
					const statusSpan = stateSpan.querySelector(
						'.states-dropdown_with-status__status-option'
					);
					statusSpan && stateSpan.removeChild(statusSpan);
					stateSpan.classList.add('dropdown-item');
					const optionText = stateSpan.innerHTML;
					let stateStatus =
						type === 'states-waitlist'
							? locationEl.current.props.options.filter(
									(option) =>
										option.label.trim() ===
										optionText.trim()
								)[0].providerWaistlistStatus
							: locationEl.current.props.options.filter(
									(option) =>
										option.label.trim() ===
										optionText.trim()
								)[0].status;

					const infoNode = document.createElement('SPAN');
					infoNode.classList.add(
						'states-dropdown_with-status__status-option'
					);
					const className = stateStatus
						.replace(/[\(\)]/g, '')
						.replace(' ', '-')
						.toLowerCase();

					infoNode.classList.add(className);
					if (stateStatus === STATE_STATUSES.COMINGSOON) {
						stateStatus = 'Coming soon';
					} else if (stateStatus === STATE_STATUSES.LIMITED) {
						stateStatus = 'Available (limited)';
					} else if (stateStatus === STATE_STATUSES.UNAVAILABLE) {
						stateStatus = 'Get notified';
					} else {
						stateStatus = 'Available';
					}

					const stateInfo = document.createTextNode(stateStatus);
					infoNode.appendChild(stateInfo);
					stateSpan.appendChild(infoNode);
				});
		}, 0);
	};

	const setStateAndScrollToForm = async () => {
		const mktoFormEl = formToScrollTo.querySelector('form.mktoForm');
		if (mktoFormEl) {
			const formId = +mktoFormEl.id.split('mktoForm_')[1];
			const mktoFormObject = window.MktoForms2?.getForm(formId);
			await mktoFormObject.setValues({
				State_of_License__c: selectedState,
			});
		}

		window.scrollTo({
			left: 0,
			top: formToScrollTo.offsetTop,
			behavior: 'smooth',
		});
	};

	const handleDropdownStateSelect = (option) => {
		setSelectedState(option[0].label);
		if (type === 'states-waitlist') {
			setSelectedStateStatus(option[0].providerWaistlistStatus);
		} else {
			setSelectedStateStatus(option[0].status);
		}
	};

	const handleDropdownServiceSelect = (options) => {
		setSelectedServices(options.map((option) => option.value));
	};

	const injectCTACopy = (type = '', selectedStateStatus = '') => {
		if (
			selectedStateStatus === STATE_STATUSES.AVAILABLE ||
			selectedStateStatus === STATE_STATUSES.LIMITED
		) {
			return type === 'states-waitlist'
				? 'Get in touch'
				: 'See therapists';
		} else if (selectedStateStatus === STATE_STATUSES.COMINGSOON) {
			return type === 'states-waitlist'
				? 'Join the waitlist'
				: 'Get notified';
		}
		return 'Get notified';
	};

	return (
		<div className='states-container'>
			<div className='form-container'>
				<form
					id='states-dropdown-form'
					className='form p0'
					autoComplete='on'
				>
					<div
						className='field-group states-dropdown states-dropdown_with-status'
						style={{ width: '100%' }}
					>
						<div className='field-group__inner  rel'>
							<div className='gray' htmlFor='mce-MMERGE7'>
								<Dropdown
									dropdownHandle={false}
									ref={locationEl}
									name={'alma_states'}
									options={statesOptions}
									onChange={(option) =>
										handleDropdownStateSelect(option)
									}
									handleKeyDownFn={() => {
										addStateStatusSpan();
									}}
									onDropdownOpen={() => {
										const selectedOptionSpan =
											locationEl.current.select.current.querySelector(
												'.react-dropdown-select-type-single span'
											);
										if (selectedOptionSpan) {
											selectedOptionSpan.innerHTML = '';
										} else {
											locationEl.current.select.current.querySelector(
												'.react-dropdown-select-type-single input'
											).placeholder = 'Select your state';
										}
										addStateStatusSpan();
									}}
									value={selectedState}
									placeholder='Select your state'
								/>
								{servicesVisibility && (
									<Dropdown
										dropdownHandle={false}
										ref={servicesEl}
										name={'alma_services'}
										options={serviceNodes.map(
											(service) => ({
												value: service.value,
												label: service.title,
											})
										)}
										onChange={(options) =>
											handleDropdownServiceSelect(options)
										}
										value={selectedServices}
										placeholder='Select your service'
									/>
								)}
							</div>
						</div>
					</div>
				</form>
				<div className='field-group f aie submit-container'>
					<div
						className={`field-group__inner x f ${type === 'states-waitlist' ? type : ''} jcs`}
					>
						<button
							className='submit-button btn'
							id='submit'
							type='submit'
							onClick={() => {
								if (type === 'states-waitlist') {
									selectedStateStatus ===
										STATE_STATUSES.AVAILABLE ||
									selectedStateStatus ===
										STATE_STATUSES.LIMITED
										? (window.location.href =
												'/for-providers/#form')
										: setStateAndScrollToForm();
								} else {
									selectedStateStatus ===
										STATE_STATUSES.AVAILABLE ||
									selectedStateStatus ===
										STATE_STATUSES.LIMITED
										? handleDirectoryRedirect(
												selectedState,
												selectedServices
											)
										: setStateAndScrollToForm();
								}
							}}
						>
							{injectCTACopy(type, selectedStateStatus)}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
